import Vue from "vue";
import Vuetify, {
  VApp, // required
  VNavigationDrawer,
  VFadeTransition,
  VLayout,
  VCard,
  VCardTitle,
  VCardText,
  VCardActions,
  VSheet
} from "vuetify/lib"
import {
  Ripple
} from "vuetify/lib/directives"
import colors from "vuetify/es5/util/colors";

Vue.use(Vuetify);

const opts = {
  components: {
    VApp,
    VNavigationDrawer,
    VFadeTransition,
    VLayout,
    VCard,
    VCardTitle,
    VCardText,
    VCardActions,
    VSheet
  },

  directives: {
    Ripple
  },

  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: colors.grey.darken4,
        secondary: colors.grey.darken1,
        accent: colors.yellow.accent3
      },
      dark: {
        primary: colors.yellow.accent3,
        secondary: colors.grey.darken2,
        accent: colors.grey.darken2
      }
    }
  },

  icons: {
    iconfont: "mdi", // default
    values: {
      customers_confirmed:"mdi-check-circle-outline",
      customers_activated: "mdi-check-decagram-outline",
      customers_nomatch: "mdi-account-question-outline",
      customers_export: "mdi-database-export-outline",
      export: "mdi-database-export-outline",
      policies: "mdi-shield-outline",
      insurance: "mdi-shield-outline",
      surveys: "mdi-comment-question-outline",
      properties: "mdi-home-outline",
      rewards: "mdi-cash",
      user: "mdi-shield-account-outline",

      home: "mdi-google-home",
      dashboard: 'mdi-finance',//'mdi-monitor-dashboard',
      
      car: "mdi-car-back",
      camera: "mdi-camera",
      camera_take: "mdi-camera-plus",
      camera_retake: "mdi-camera-retake-outline",
      
      settings: "mdi-settings-outline",
      close: "mdi-close-circle-outline",
      more: "mdi-dots-vertical",
      back: "mdi-arrow-left",
      print: "mdi-printer-wireless",

      pdf: "mdi-file-pdf",
      xsl: "mdi-file-excel",
      report: "mdi-file-excel",

      login: "mdi-fingerprint",
      logout: "mdi-fingerprint-off",

      continue: "mdi-play-circle-outline",
      search: "mdi-magnify",
      edit: "mdi-circle-edit-outline",
      play: "mdi-motion-play-outline",
      send: "mdi-send",
      sync: "mdi-autorenew",
      sync_cloud: "mdi-cloud-sync-outline",
      sync_db: "mdi-database-sync",

      address: "mdi-map-search-outline",
      map: "mdi-google-maps",
      email: "mdi-at",
      password: "mdi-lock-question",
      phone: "mdi-cellphone-android",

      vehicle: "mdi-car",
      odometer: "mdi-gauge",
      reward: "mdi-trophy-variant-outline", 
      payout: "mdi-currency-usd", 

      required: "mdi-asterisk",
      install: "mdi-progress-download",
      download: "mdi-download",
      update: "mdi-sync", //"mdi-cellphone-arrow-down",
      remove: "mdi-delete-empty-outline",
      add: "mdi-plus",
      add_calendar: "mdi-calendar-plus",
      date: "mdi-calendar",
      correct:"mdi-check-all",
      correct_info:"mdi-check",
      incorrect:"mdi-close",

      mini_mode: "mdi-arrow-expand",
      dark_mode: "mdi-battery-charging-100",
      bright_mode: "mdi-battery-charging-30",

      notifications_on: "mdi-bell-ring-outline",
      notifications_off: "mdi-bell-outline",

      network_on: "mdi-wifi", //'mdi-access-point-network',
      network_off: "mdi-wifi-off", //'mdi-access-point-network-off'
      network_warn: "mdi-wifi-strength-alert-outline", //'mdi-access-point-network-off'

      microsoft: "mdi-microsoft",
      microsoft_office: "mdi-microsoft-office",
      microsoft_outlook: "mdi-microsoft-outlook",
      ics: "mdi-calendar-clock",
      google: "mdi-google",
      apple: "mdi-apple",
      facebook: "mdi-facebook",
      amazon: "mdi-amazon",
      yahoo: "mdi-yahoo"
    }
  }
};

export default new Vuetify(opts);